import { Site } from "@inrange/building-manager-api-client/models-site";

export type PvLayoutQuality = "high" | "medium" | "low";

// Helpers for reading the generic `site.reviews` state written by the
// bulk-review surface. The backing shape (BMA Site.reviews) is:
//   reviews.boundary = { at, by }
//   reviews.pvLayout = { at, by, quality }
// A pvLayout review is only valid if it was recorded at/after the latest
// boundary review: editing the boundary bumps boundary.at, which supersedes
// any prior PV verdict without us having to delete it (deep_merge can't clear
// a sub-dict). See building-manager-api Site.reviews docs.

export const getBoundaryReviewedAt = (site: Site): number | undefined =>
  site.reviews?.boundary?.at;

export const getPvLayoutQuality = (
  site: Site
): PvLayoutQuality | undefined => {
  const pv = site.reviews?.pvLayout;
  if (pv?.at == null) return undefined;
  const boundaryAt = site.reviews?.boundary?.at ?? 0;
  return pv.at >= boundaryAt
    ? (pv.quality as PvLayoutQuality | undefined)
    : undefined;
};
